import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import analysisReducer from "../dashboard/analysis/analysisSlice";
import qualitativeAnalysisReducer from '../dashboard/analysis/qualitativeAnalysisSlice';
import dataCleaningReducer from "../dashboard/data-cleaning/dataCleaningSlice";
import dataDashboardReducer from "../dashboard/data-dashboard/dashboardSlice";
import tableReducer from "../dashboard/table-conversation/tableSlice";
import agentReducer from "../dashboard/agent/agentSlice";
import persistReducer from "redux-persist/es/persistReducer";
import userSlice from "../dashboard/userSlice";
import persistStore from "redux-persist/es/persistStore";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const userPersisted = persistReducer(persistConfig, userSlice);

const dashboardPersistConfig = {
  key: "dataDashboardV2",
  storage,
};
const dataDashboardPersisted = persistReducer(dashboardPersistConfig, dataDashboardReducer);

const appReducer = combineReducers({
  user: userPersisted,
  analysis: analysisReducer,
  dataCleaning: dataCleaningReducer,
  qualitativeAnalysis: qualitativeAnalysisReducer,
  dataDashboard: dataDashboardPersisted,
  conversation: tableReducer,
  agent: agentReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'user/logout') {
    // Keep user state so redux-persist metadata isn't lost, 
    // but reset all other slices to undefined.
    state = {
      user: state?.user,
      analysis: undefined,
      dataCleaning: undefined,
      qualitativeAnalysis: undefined,
      dataDashboard: undefined,
      conversation: undefined,
      agent: undefined,
    };
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // serializableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store); 